import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports/inbound-lane-detail");

export const Route = createFileRoute("/reports/inbound-lane-detail")({
  head: () => ({
    meta: [
      { title: "Inbound lane detail report — LevelLoad" },
      {
        name: "description",
        content: "Inbound lane detail report — LevelLoad transport planning.",
      },
      { property: "og:title", content: "Inbound lane detail report — LevelLoad" },
      {
        property: "og:description",
        content: "Inbound lane detail report — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
